import { apiClient } from '@/shared/api';
import { API_ENDPOINTS } from '@/config';
import { buildCommonHeaders } from '@/shared/http/commonHeaders';
import { CustomerSummaryData, CustomerSummaryResponse } from '../types/customer.types';

export const customerService = {
    async getCustomerSummary(): Promise<CustomerSummaryData> {
        const headers = buildCommonHeaders({ withLocation: true });
        const response = await apiClient.post<CustomerSummaryResponse>(
            API_ENDPOINTS.customer.summary,
            {},
            { headers }
        );
        return response.data.data;
    }
};
